module.exports = __webpack_public_path__ + "static/media/default_empty_logo.193d2ff8.jpg";